import { AlertTriangle, CheckCircle2, Sparkles, Users } from 'lucide-react';
import React from 'react';

import type { AgentsSummaryResponse } from '@/pages/analytics/types';
import { formatInt } from '@/pages/analytics/utils/formatters';
import { formatAggregateScore, SCORE_BAND_MEETS_MIN } from '@/pages/qc/utils';

import { KpiCard } from './KpiCard';

interface AgentsKpiCardsProps {
  summary?: AgentsSummaryResponse;
  loading?: boolean;
}

// Icon palette mirrors the prototype: soft-tinted backgrounds with the
// foreground icon in the matching saturated tone. We use theme tokens
// (primary / positive / attention) so dark mode keeps working.
export const AgentsKpiCards: React.FC<AgentsKpiCardsProps> = ({ summary, loading }) => {
  const total = summary?.total_agents ?? 0;
  const avg = summary?.avg_score ?? 0;
  const passing = summary?.agents.filter(a => a.avg_score >= SCORE_BAND_MEETS_MIN).length ?? 0;
  const belowCoaching = summary?.agents.filter(a => a.avg_score < SCORE_BAND_MEETS_MIN).length ?? 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <KpiCard
        layout="horizontal"
        icon={Users}
        iconClassName="bg-primary/10 text-primary"
        label="Total Agents"
        value={summary ? formatInt(total) : '—'}
        loading={loading}
      />
      <KpiCard
        layout="horizontal"
        icon={Sparkles}
        iconClassName="bg-positive/10 text-positive-foreground"
        label="Avg Score"
        value={summary ? formatAggregateScore(avg) : '—'}
        loading={loading}
      />
      <KpiCard
        layout="horizontal"
        icon={CheckCircle2}
        iconClassName="bg-primary/10 text-primary"
        label="Passing"
        value={summary ? formatInt(passing) : '—'}
        loading={loading}
      />
      <KpiCard
        layout="horizontal"
        icon={AlertTriangle}
        iconClassName="bg-attention/10 text-attention-foreground"
        label="Below Threshold"
        value={summary ? formatInt(belowCoaching) : '—'}
        loading={loading}
      />
    </div>
  );
};
